import React from 'react'

import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'
import { setAuthStartedCookie } from '@mc/email-capture'
import { Locations, track, getPageSource } from '@mc/track-event'
import { CheckoutEvents } from '@mc/pre-paywall-events'

import { EMAIL_CAPTURE_PROMO_MODAL_I18N_NAMESPACE } from './i18n'

// copied from web/apps/checkout/src/components/WarningBox/WarningBox.tsx with modifications on the event
// if productized: we could move to ui/growth
export const WarningBox = ({ children }: { children: React.ReactNode }) => (
  <div
    className='mc-corners--sm mc-p-3 mc-my-6'
    style={{ background: '#FFDCAD' }}
  >
    <div className='d-flex'>
      <div aria-live='assertive' className='mc-text-color--dark mc-text-small'>
        {children}
      </div>
    </div>
  </div>
)

export const EmailAlreadyRegisteredWarning = () => {
  const redirectPath = paths.logIn(paths.checkout)

  const handleClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    // get Anchor text
    const { textContent } = evt.target as HTMLElement

    if (textContent) {
      // same as web/libs/pre-paywall-events/src/events/shared/checkoutCTAClicked.ts
      // with some property changes
      track(CheckoutEvents.EVENTS.CHECKOUT_CTA_CLICKED, {
        location: Locations.PROMOTION_MODAL,
        action: textContent,
        page_source: getPageSource(),
      })

      setAuthStartedCookie()
    }
  }

  return (
    <WarningBox>
      <Trans
        i18nKey='error.emailAlreadyExist'
        ns={EMAIL_CAPTURE_PROMO_MODAL_I18N_NAMESPACE}
      >
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a
          className='mc-text--link'
          onClick={handleClick}
          href={redirectPath}
        />
      </Trans>
    </WarningBox>
  )
}
